export const COUNTERPARTY_DIGITS_MASK = {
  inn: '#'.repeat(12),
  kpp: '#'.repeat(9),
  ogrn: '#'.repeat(15),
  okpo: '#'.repeat(10),
  okato: '#'.repeat(11),
} as const;
